export default function Services() {
  const services = [
    {
      icon: 'ri-temp-cold-line',
      title: 'Pompes à Chaleur',
      description: 'Installation et maintenance de pompes à chaleur air/eau et air/air pour un chauffage efficace et économique.',
      features: ['Air/Eau', 'Air/Air', 'Haute performance', 'Économies d\'énergie']
    },
    {
      icon: 'ri-water-flash-line',
      title: 'Ballons Thermodynamiques',
      description: 'Solutions d\'eau chaude sanitaire écologiques utilisant l\'énergie de l\'air pour chauffer votre eau.',
      features: ['Écologique', 'Économique', 'Installation rapide', 'Faible consommation']
    },
    {
      icon: 'ri-home-4-line',
      title: 'Isolation',
      description: 'Amélioration de l\'isolation thermique de votre habitation pour optimiser vos performances énergétiques.',
      features: ['Isolation murs', 'Isolation combles', 'Réduction factures', 'Confort thermique']
    },
    {
      icon: 'ri-tools-line',
      title: 'Plomberie',
      description: 'Services complets de plomberie pour l\'installation et la maintenance de vos systèmes sanitaires.',
      features: ['Installation', 'Dépannage', 'Maintenance', 'Rénovation']
    }
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nos Services Professionnels
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Des solutions complètes pour tous vos besoins en chauffage, isolation et plomberie
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-teal-600 text-white rounded-xl mb-6">
                <i className={`${service.icon} text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-sm text-gray-700">
                    <i className="ri-check-line text-teal-600"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
